export { default } from './SwitchToPayrollBanner';
